import { cn } from '@/renderer/lib/utils';
import React from 'react';

interface BillingStatusBadgeProps {
  icon?: React.ReactNode;
  label: string;
  size?: 'sm' | 'md';
  tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'inverse';
}

const toneClasses: Record<
  NonNullable<BillingStatusBadgeProps['tone']>,
  string
> = {
  neutral: 'border-slate-200 bg-white/85 text-slate-600',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  warning: 'border-amber-200 bg-amber-50 text-amber-700',
  danger: 'border-rose-200 bg-rose-50 text-rose-700',
  inverse: 'border-white/15 bg-white/10 text-white/85',
};

export const BillingStatusBadge: React.FC<BillingStatusBadgeProps> = ({
  icon,
  label,
  size = 'sm',
  tone = 'neutral',
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium backdrop-blur-sm',
        size === 'sm' ? 'px-2.5 py-1 text-[11px]' : 'px-3 py-1.5 text-xs',
        toneClasses[tone],
      )}
    >
      {icon}
      <span>{label}</span>
    </span>
  );
};
